<script setup>
    import { defineProps } from "vue";

    const props = defineProps({
        iconWidth: String,
        iconHeight: String,
    });
</script>


<template>
    <svg 
        :width="iconWidth" 
        :height="iconHeight" 
        viewBox="0.5 -5 30 30" 
        version="1.1" 
        xmlns="http://www.w3.org/2000/svg" 
        xmlns:xlink="http://www.w3.org/1999/xlink" 
        xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
    >
        <g 
            id="Page-1" 
            stroke="none" 
            stroke-width="1" 
            fill="none" 
            fill-rule="evenodd" 
            sketch:type="MSPage"
        >
            <g 
                id="Icon-Set" 
                sketch:type="MSLayerGroup" 
                transform="translate(-206.000000, -831.000000)" 
                fill="currentColor"
            >
                <path d="
                    M211.218,847 C212.146,842.438 216.161,839 221,839 C225.839,839 229.854,842.438 230.782,847 
                    L232.886,847 C232.118,841.359 227.096,837 221,837 C214.904,837 209.882,841.359 209.114,847 
                    L211.218,847 L211.218,847 Z M235,849 L207,849 C206.448,849 206,849.447 206,850 C206,850.553 
                    206.448,851 207,851 L235,851 C235.552,851 236,850.553 236,850 C236,849.447 235.552,849 235,849 
                    L235,849 Z M209,839.414 C209.391,839.805 210.024,839.805 210.414,839.414 C210.805,839.023 
                    210.805,838.391 210.414,838 L209,836.586 C208.609,836.195 207.977,836.195 207.586,836.586 
                    C207.195,836.977 207.195,837.609 207.586,838 L209,839.414 L209,839.414 Z M233,839.414 L234.414,838 
                    C234.805,837.609 234.805,836.977 234.414,836.586 C234.023,836.195 233.391,836.195 233,836.586 
                    L231.586,838 C231.195,838.391 231.195,839.023 231.586,839.414 C231.977,839.805 232.609,839.805 
                    233,839.414 L233,839.414 Z M221,835 C221.552,835 222,834.553 222,834 L222,832 C222,831.448 
                    221.552,831 221,831 C220.448,831 220,831.448 220,832 L220,834 C220,834.553 220.448,835 221,835 
                    L221,835 Z" 
                    sketch:type="MSShapeGroup"
                ></path>
            </g>
        </g>
    </svg>    
</template>